import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=36ef006c"
import script from "./FavoriteButton.vue?vue&type=script&lang=ts"
export * from "./FavoriteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ef006c')) {
      api.createRecord('36ef006c', component.options)
    } else {
      api.reload('36ef006c', component.options)
    }
    module.hot.accept("./FavoriteButton.vue?vue&type=template&id=36ef006c", function () {
      api.rerender('36ef006c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/FavoriteButton.vue"
export default component.exports